import * as React from 'react';
import { ButtonIcon } from 'controller/components/ButtonIcon';
import styled from 'styled-components';
import Tooltip from '../controller/components/ButtonTooltip';
import { storeDispatch } from 'state/Store';
import * as Actions from '../state/actions';

interface Props {
  flyerId: string | null | undefined;
  pastLength: number;
  futureLength: number;
  hide: boolean;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 6px;

  button {
    margin: 0 4px;
  }
`;

const UndoRedoButtons: React.FC<Props> = ({
  flyerId,
  pastLength,
  futureLength,
  hide
}) => {
  const undo = React.useCallback(() => {
    storeDispatch(Actions.undo());
  }, []);

  const redo = React.useCallback(() => {
    storeDispatch(Actions.redo());
  }, []);

  if (flyerId === null || hide) {
    return null;
  }

  return (
    <Wrapper id="undo-redo">
      <Tooltip placement="bottom" text="Undo" hide={pastLength === 0}>
        <ButtonIcon icon="undo" onClick={undo} disabled={pastLength === 0} />
      </Tooltip>
      <Tooltip placement="bottom" text="Redo" hide={futureLength === 0}>
        <ButtonIcon icon="redo" onClick={redo} disabled={futureLength === 0} />
      </Tooltip>
    </Wrapper>
  );
};

export { UndoRedoButtons };



// WEBPACK FOOTER //
// ./src/showcase/UndoRedoButtons.tsx